<template>
  <div ref='byCodeMarket' style='min-height:450px'></div>
</template>

<script>
  /* Imports */
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  export default {
    data () {
      return{
        chart : null,
      }
    },
    props : ['filterUrl'],
    mounted () {
      this.createChart();
    },
    watch : {
      filterUrl : {
        handler : 'fetchData'
      }
    },
    methods : {
      fetchData(){
        let length = this.chart.data.length
        this.$http.get('/api/h1/average-days-of-stock/by-codemarket?' + this.filterUrl)
        .then((resp)=>{
          var data = resp.data.data

          if (data.length < 1) {
            data.push({
              codeMarket: 'No Data',
              average: 1
            })
          }

          for (var i = 0 ; i < data.length ; i++) {
            data[i].calc = Math.round(data[i].average / 24 * 100) /100
            data[i].day = Math.floor(data[i].calc)
            data[i].hour = Math.floor((data[i].calc % 1) * 24)
          }
          this.chart.addData(data, length)
        })
        .catch((err)=>{
          console.log(err);
        })
      },
      createChart(){
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        // Create chart instance
        this.chart = am4core.create(this.$refs.byCodeMarket, am4charts.PieChart);

        // Add and configure Series
        let pieSeries = this.chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "average";
        pieSeries.dataFields.category = "codeMarket";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeWidth = 2;
        pieSeries.slices.template.strokeOpacity = 1;
        pieSeries.slices.template.tooltipText = '{codeMarket}: [bold]{day} Days {hour} H'
        
        pieSeries.slices.template.stroke = am4core.color('#BDBDBD')
        pieSeries.slices.template.strokeWidth = 1
        pieSeries.slices.template.strokeOpacity = 1

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

      }
    }
  }
</script>